<template>
  <ValidationObserver ref="observer">
    <v-form @submit.prevent="submit">
      <p
        class="text-left mt-6 mb-0"
        v-if="whitelabel.authentication.signUp.showEmail"
      >
        Email: <b>{{ verifyUserLinkCode.email }}</b>
      </p>
      <p
        class="text-left mt-6 mb-0"
        v-if="whitelabel.authentication.signUp.showUniqueIdentifier"
      >
        Industry Number: <b>{{ verifyUserLinkCode.uniqueIdentifier }}</b>
      </p>
      <p
        class="text-left mt-6 mb-0"
        v-if="whitelabel.authentication.signUp.showPhone"
      >
        Phone: <b>{{ verifyUserLinkCode.phone }}</b>
      </p>
      <h4 class="text-left">Create a password to activate your account</h4>
      <ValidationProvider
        id="password"
        v-slot="{ errors }"
        name="password"
        rules="required|password"
      >
        <v-text-field
          id="landing_page_first_input"
          v-model="password"
          :error-messages="errors"
          :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
          :type="showPassword ? 'text' : 'password'"
          label="Password"
          @click:append="showPassword = !showPassword"
        />
      </ValidationProvider>

      <ValidationProvider
        id="confirm_password"
        v-slot="{ errors }"
        name="confirm_password"
        rules="required|confirmed:password"
      >
        <v-text-field
          v-model="confirmPassword"
          :error-messages="errors"
          :append-icon="showConfirmPassword ? icons.mdiEye : icons.mdiEyeOff"
          :type="showConfirmPassword ? 'text' : 'password'"
          label="Confirm Password"
          @click:append="showConfirmPassword = !showConfirmPassword"
        />
      </ValidationProvider>

      <ValidationProvider
        v-if="newUser"
        id="accepted_terms"
        v-slot="{ errors }"
        name="accepted_terms"
        :rules="{ is: [true] }"
      >
        <v-checkbox
          v-model="acceptedTerms"
          color="primary"
          :error-messages="errors"
        >
          <template #label>
            <div>
              By signing up, I accept
              <a
                target="_blank"
                :href="whitelabel.termsAndConditionsLocation"
                @click.stop
                >{{ whitelabel.name }}'s terms &amp; conditions</a
              >
            </div>
          </template>
        </v-checkbox>
      </ValidationProvider>

      <v-btn
        rounded
        large
        depressed
        type="submit"
        color="primary"
        :loading="buttonLoading"
      >
        <span>Activate account</span><v-icon>{{ icons.mdiArrowRight }}</v-icon>
      </v-btn>
    </v-form>

    <ErrorSnackbar v-model="showError" />
  </ValidationObserver>
</template>

<script>
  import ErrorSnackbar from '../../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../../mixins/form-helper-mixin';
  import { SET_PASSWORD_AND_LOGIN_MUTATION } from '../../../constants/graphql/authentication';
  import * as Sentry from '@sentry/browser';

  export default {
    name: 'ActivateAccountForm',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      verifyUserLinkCode: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        password: null,
        confirmPassword: null,
        acceptedTerms: false,
        showPassword: false,
        showConfirmPassword: false,
      };
    },
    computed: {
      newUser() {
        return !this.verifyUserLinkCode.acceptedTerms;
      },
    },
    methods: {
      submit() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.setPasswordAndLogin();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      setPasswordAndLogin() {
        const userLinkCode = this.$route.params.id;
        const password = this.password;
        const acceptedTerms = this.acceptedTerms;

        this.$apollo
          .mutate({
            mutation: SET_PASSWORD_AND_LOGIN_MUTATION,
            variables: {
              userLinkCode,
              password,
              acceptedTerms,
            },
          })
          .then(result => {
            const setPasswordAndLogin = result.data.setPasswordAndLogin;
            const accessToken = setPasswordAndLogin.accessToken;
            const refreshToken = setPasswordAndLogin.refreshToken;
            const testatorId = setPasswordAndLogin.testatorId;
            const userId = setPasswordAndLogin.userId;
            const willCountry = setPasswordAndLogin.willCountry;

            this.$store.dispatch('login', {
              accessToken,
              refreshToken,
              testatorId,
              userId,
              willCountry,
            });
            this.setSentryUser(userId);
            this.redirectToNext();
          })
          .catch(error => {
            this.handleMutationError(error);
          });
      },
      setSentryUser(userId) {
        Sentry.setUser({ id: userId });
      },
      handleMutationError(error) {
        this.buttonLoading = false;
        this.displayError();
        throw error;
      },
      redirectToNext() {
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          this.$router.push('/overview');
        }
      },
    },
  };
</script>
